<!--  -->
<template>
  <div id="map"></div>
</template>

<script>
import { Layers, layers } from "@/utils/customLayerControl.js";
import { utlogMap } from "@/api/index.js";
import { functionId } from "@/utils/browser.js";
const defaultZoom = 4;
export default {
  props: {
    mapData: Array,
  },
  data() {
    return {
      points: [],
      iconUrl: require("../assets/images/marker-icon-2x.png"),
      shadowUrl: require("../assets/images/marker-shadow.png"),
      //   centerPoints: [39.73, -104.99],//北美洲
      centerPoints: [32.13841, 87.97852], // 西藏
      layerGroup: L.layerGroup(),
      canvasLayer: L.canvasIconLayer({}),
      canvasMarkers: [],
      addToLayerGroup: false,
      overviewLayer: null,
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    // console.log("haha");
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.initMap();
    this.$nextTick(() => {
      // const controlDom = document.querySelector(
      //   ".leaflet-control-layers-selector"
      // );
      // controlDom.addEventListener(
      //   "click",
      //   function (el) {
      //     const isChecked = controlDom.checked;
      //     let logMap = {
      //       eventType: "clk",
      //       url: window.location.href,
      //       functionId: functionId({
      //         pageName: "explor",
      //         module: "overview",
      //         func: "controlDomClick",
      //       }),
      //       utlogMap: {
      //         showMarkers: isChecked,
      //       },
      //     };
      //     utlogMap(logMap);
      //   },
      //   false
      // );
    });
  },
  methods: {
    initMap() {
      if (!this.map) {
        const map = L.map("map", {
          minZoom: 1,
          maxZoom: 20,
          center: this.centerPoints,
          targetPoints: [],
          zoom: defaultZoom,
          zoomControl: true,
          layers: [this.layerGroup],
          // fullscreenControl: true,
          fullscreenControl: {
            pseudoFullscreen: false, // if true, fullscreen to page width and height
          },
          attributionControl: true,
          preferCanvas: true,
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
          crs: L.CRS.EPSG3857,
        });
        this.map = map; // data上需要挂载
        window.map = map;
        this.addTileLayer({
          mapTitle:
            "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
        });
        this.addTileLayer({
          // mapTitle: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          mapTitle:
            "https://webst0{s}.is.autonavi.com/appmaptile?style=7&x={x}&y={y}&z={z}",
          attr: {
            attribution: "天地图 - 简略边界图",
            subdomains: ["1", "2", "3", "4"],
            maxZoom: 18, // 天地图最大缩放等级
            // '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          },
        });
        this.addMark();
        const overlayMaps = {
          overview: this.layerGroup,
        };
        // null此位置的参数使用radio，第二个参数表示使用checkbox显示选中
        // {hideSingleBase: false,visible:true,collapsed:false}
        layers(null, overlayMaps, {
          overview: this.layerGroup,
          canvasLayer: this.canvasLayer,
          markers: this.canvasMarkers,
          map: this.map,
        }).addTo(map);
      } else {
        // this.layerGroup.clearLayers();
        this.addMark();
      }
    },
    controlDomClick() {
      console.log("haha");
    },
    addMark() {
      const imgIcon = L.icon({
        iconUrl: this.iconUrl,
        shadowUrl: this.shadowUrl,
        iconSize: [15, 25],
        shadowSize: [25, 25],
        iconAnchor: [7.5, 25],
        popupAnchor: [0, -25],
        tooltipAnchor: [16, -28],
      });
      if (this.points.length) {
        for (let i = 0; i < this.points.length; i++) {
          const curPoint = this.points[i];
          // lat lng
          // L.marker(curPoint.centerPoints, { icon: imgIcon }).addTo(this.canvasLayer);
          const marker = L.marker(curPoint.centerPoints, { icon: imgIcon });
          if (curPoint.title) {
            marker.bindPopup(curPoint.title);
          }
          this.canvasMarkers.push(marker);
        }
        if (!this.addToLayerGroup) {
          // 只针对单个canvas图层添加和删除markers
          this.canvasLayer.addTo(this.layerGroup);
          this.addToLayerGroup = true;
        }
        this.canvasLayer.addLayers(this.canvasMarkers);
      } else {
        this.clearCanvasMap();
      }
      // this.layerGroup.addTo(this.map);
    },
    clearCanvasMap() {
      if (this.canvasMarkers.length) {
        for (let i = 0; i < this.canvasMarkers.length - 1; i++) {
          this.canvasLayer.removeMarker(this.canvasMarkers[i]);
        }
        this.canvasLayer.removeMarker(
          this.canvasMarkers[this.canvasMarkers.length - 1],
          true
        ); // true重绘

        while (this.canvasMarkers.length) {
          this.canvasMarkers.shift();
        }
        //  this.$set(this, "canvasMarkers", []);
      }
    },
    addTileLayer(options) {
      L.tileLayer(options.mapTitle, { ...options.attr }).addTo(this.map);
    },
  },
  watch: {
    mapData: {
      handler: function (val) {
        document.querySelector(
          ".leaflet-control-layers-selector"
        ).checked = true;
        const points = val;
        this.points = points;
        if (this.points.length) {
          this.centerPoints = this.points[0]?.centerPoints;
          if (this.map) {
            this.map.setView(this.centerPoints, defaultZoom, {
              animation: true,
            }); // 中心点，缩放等级，可选参数
          }
        }
        this.clearCanvasMap();
        this.initMap();
      },
    },
  },
};
</script>
<style>
#map {
  width: 100%;
  height: 100%;
  z-index: 50;
}
</style>
